import { render, staticRenderFns } from "./kfixedgriditem.vue?vue&type=template&id=0a72ad73&scoped=true"
import script from "./kfixedgriditem.vue?vue&type=script&lang=js"
export * from "./kfixedgriditem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a72ad73",
  null
  
)

export default component.exports